import React from 'react';
import { Link } from 'react-router-dom';
import SEO, { SEOPages } from '../components/SEO';

const Confidentialite = () => {
  return (
    <div className="pt-20">
      <SEO {...SEOPages.confidentialite} />
      <section className="py-20">
        <div className="container max-w-4xl mx-auto">
          <div className="glass p-12 rounded-3xl">
            <h1 className="text-4xl font-bold heading-display text-white mb-8">
              Politique de confidentialité
            </h1>

            <div className="space-y-8 text-gray-300">
              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Introduction</h2>
                <p>
                  ATOM Group SA s'engage à protéger la confidentialité et la sécurité de vos données 
                  personnelles. Cette politique de confidentialité explique comment nous collectons, 
                  utilisons, stockons et protégeons vos informations personnelles conformément à la 
                  Loi fédérale sur la protection des données (LPD) et au Règlement général sur la 
                  protection des données (RGPD).
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Données collectées</h2>
                <p className="mb-4">Nous collectons les types de données suivants :</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong className="text-white">Données d'identification :</strong> nom, prénom, adresse, téléphone, email</li>
                  <li><strong className="text-white">Données financières :</strong> informations sur votre situation financière, revenus, patrimoine</li>
                  <li><strong className="text-white">Données de navigation :</strong> adresse IP, cookies, pages visitées</li>
                  <li><strong className="text-white">Données de communication :</strong> échanges par email, téléphone ou formulaires</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Finalités du traitement</h2>
                <p className="mb-4">Vos données sont utilisées pour :</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Fournir nos services de conseil financier</li>
                  <li>Répondre à vos demandes et questions</li>
                  <li>Améliorer nos services et notre site web</li>
                  <li>Respecter nos obligations légales et réglementaires</li>
                  <li>Vous informer de nos nouveaux services (avec votre consentement)</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Base légale</h2>
                <p>Le traitement de vos données repose sur :</p>
                <ul className="list-disc list-inside space-y-2 ml-4 mt-4">
                  <li>Votre consentement explicite</li>
                  <li>L'exécution d'un contrat de services</li>
                  <li>Le respect d'obligations légales</li>
                  <li>La poursuite d'intérêts légitimes</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Partage des données</h2>
                <p>
                  Nous ne vendons, ne louons ni ne partageons vos données personnelles avec des tiers, 
                  sauf dans les cas suivants :
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4 mt-4">
                  <li>Avec votre consentement explicite</li>
                  <li>Pour respecter une obligation légale</li>
                  <li>Avec nos partenaires de confiance (assureurs, banques) dans le cadre de nos services</li>
                  <li>Avec nos prestataires techniques sous contrat de confidentialité</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Sécurité des données</h2>
                <p>
                  Nous mettons en place des mesures techniques et organisationnelles appropriées pour 
                  protéger vos données contre tout accès non autorisé, altération, divulgation ou 
                  destruction. Nos systèmes sont hébergés en Suisse et respectent les standards de 
                  sécurité les plus élevés.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Conservation des données</h2>
                <p>
                  Nous conservons vos données personnelles uniquement pendant la durée nécessaire aux 
                  finalités pour lesquelles elles ont été collectées, et conformément aux obligations 
                  légales de conservation (généralement 10 ans pour les documents financiers).
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Vos droits</h2>
                <p className="mb-4">Vous disposez des droits suivants :</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong className="text-white">Droit d'accès :</strong> obtenir une copie de vos données</li>
                  <li><strong className="text-white">Droit de rectification :</strong> corriger des données inexactes</li>
                  <li><strong className="text-white">Droit à l'effacement :</strong> demander la suppression de vos données</li>
                  <li><strong className="text-white">Droit à la portabilité :</strong> récupérer vos données dans un format structuré</li>
                  <li><strong className="text-white">Droit d'opposition :</strong> vous opposer au traitement</li>
                  <li><strong className="text-white">Retrait du consentement :</strong> à tout moment</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Cookies</h2>
                <p>
                  Notre site utilise des cookies pour améliorer votre expérience de navigation. 
                  Vous pouvez paramétrer votre navigateur pour refuser les cookies, mais certaines 
                  fonctionnalités du site pourraient être affectées.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Contact</h2>
                <p>
                  Pour toute question concernant cette politique de confidentialité ou pour exercer 
                  vos droits, contactez-nous :
                </p>
                <div className="mt-4 space-y-2">
                  <p><strong className="text-white">Téléphone :</strong> +41 32 539 16 27</p>
                  <p><strong className="text-white">Email :</strong> contact@atom-group.ch</p>
                  <p><strong className="text-white">Adresse :</strong> ATOM Group SA, c/o Microcity SA, Rue de la Pierre-à-Mazel 39, 2000 Neuchâtel</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Modifications</h2>
                <p>
                  Cette politique de confidentialité peut être modifiée à tout moment. La version 
                  en vigueur est celle publiée sur ce site web. Nous vous informerons de tout 
                  changement significatif.
                </p>
              </section>

              <div className="pt-8 border-t border-gray-600">
                <p className="text-sm text-gray-400">
                  Version en vigueur depuis : Janvier 2025
                </p>
              </div>
            </div>

            <div className="mt-12 text-center">
              <Link to="/" className="btn-glass btn-primary px-8 py-3">
                Retour à l'accueil
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Confidentialite;